
import Input from "../../../common/input/Input";

export default function FieldDescription({ description, onChange }) {
	return (
		<>
			<Input
				onChange={onChange}
				value={description}
				label={"توضیحات وبینار"}
				placeholder={""}
			/>
		</>
	)
}
